// src/pages/docs/game/rank.jsx
import { Typography, Box, Link, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const CheckCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);

  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 600 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            {"/급식 확인"}
          </Typography>
          <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
          {command?.description ?? '설명이 없습니다.'}
          </Typography>
          <Typography variant="h6">
            {"사용법: /급식 확인 [종류] [날짜]"}<br />{"[]는 선택 사항입니다."}
          </Typography>
          <Typography variant="body1" sx={{ mt: 3}}>
          {"예시: /급식 확인 20250405"}<br />{"2025년 4월 5일의 점심을 확인합니다."}
          </Typography>          
        </Box>

        {/* 오른쪽 이미지 영역 */}
        <Box
          component="img"
          src="/commands/check.webp"
          alt="설명 이미지"
          sx={{
            width: '100%',
            maxWidth: 300,
            borderRadius: 2,
            flexShrink: 0,
            mx: 'auto',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'space-between' },
            gap: 4,
            width: { xs: '100%',md: 'auto' },
            mt:{md:-3}
          }}
        >
        {prev && (
          <Button href={prev.path} variant="outlined"sx={{height: 36, width:118 }}>
            ← {prev.name}
          </Button>
        )}
        {next && (
          <Button href={next.path} variant="outlined"sx={{height: 36, width:118 }}>
            {next.name} →
          </Button>
        )}
        </Box>
      </Box>
    </DocsLayout>
  );
};

export default CheckCommand;
